const numberToPhone = (number, delimiter = "-") => {
  const defaultPattern = /(\d{1,3})(\d{3})(\d{4}$)/;
  return number.replace(defaultPattern, `($1) $2${delimiter}$3`);
};

export default numberToPhone;
